import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const ExtendElements = styled.div`
    display: flex;
    justify-content: flex-end;
`
export const ArrowContainer = styled.div`
    width: 2rem;
    height: 100%;
    display: flex;
    align-items: center;
`

export const Container = styled.a`
    display: flex;
    padding: 5px;
    border-bottom: 1px solid ${ThemeColors.getGrayColor(0.1)};
    justify-content: space-between;
    align-items: center;
    background-color: ${ThemeColors.white};
    color: ${ThemeColors.getGrayColor(1)};
    line-height: 1.5rem;
    min-height: 52px;
    box-sizing: border-box;
`
export const SelectedImage = styled.img.attrs({
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/check_circle.svg`
})``
styled.span`
    font-size: 0.85rem;
    color: ${ThemeColors.getGrayColor(0.5)};
`
export const SkeletonContainer = styled.div`
    padding: 10px;
`

export const SkeletonContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 2.5rem;
    box-sizing: border-box;
`

export const SkeletonTitle = styled.div`
    width: 100%;
    height: 20px;
`

export const SkeletonDescription = styled.div`
    width: 60%;
    height: 15px;
`
